module.exports = __webpack_public_path__ + "img/visa.128287e4.svg";